<div class="content"
  role="main">
  @if (loginDisplay) {
    <span>Please wait while we load up the deployments...</span>
  }
  @if (!loginDisplay) {
    <span>Please login...</span>
  }
</div>
